'use strict';

(function () {
  'use strict';

  angular.module('studentLanding').controller('StudentLandingCtrl', StudentLandingCtrl);

  StudentLandingCtrl.$inject = ['$log', '$state', '$stateParams', '$window', '$http', '$q', 'domainSvc'];

  function StudentLandingCtrl($log, $state, $stateParams, $window, $http, $q, domainSvc) {
    var vm = this;
    vm.rootDomainUrl = 'https://' + domainSvc.getRootDomain();
    vm.$onInit = init;

    function init() {
      var referral = $stateParams.ref || '',
          org = $stateParams.org,
          secondary = $stateParams.sub;

      determineBranding(org, secondary).then(function (out) {
        vm.cobranding = out.cobranding;
        buildSignUpUrl(out.org, out.group, out.accessCode, referral);
      });
    }

    /**
     * Determines the branding by trying to see if the
     * secondary param is a group or an access code through promise nesting
     * @param  {String} org        the org shortname
     * @param  {String} secondary  the shortname of a group or ac
     * @return {Promise}           A promise to figure out the branding
     */
    function determineBranding(org, secondary) {
      if (!secondary) {
        //org level branding and page
        return loadOrgBranding(org);
      }
      return loadGroupBranding(org, secondary);
    }

    function loadOrgBranding(org) {
      //org level branding and page
      return loadHeaderImage(org).then(function (response) {
        return {
          org: org,
          cobranding: response
        };
      }, function () {
        return $q.when({});
      });
    }

    function loadGroupBranding(org, secondary) {
      var groupUrl = org + '/groups/' + secondary;
      return loadHeaderImage(groupUrl).then(function (response) {
        //the secondary param is a valid group in the org
        return {
          org: org,
          group: secondary,
          cobranding: response
        };
      }, function () {
        //if the secondary param was an invalid group name,
        //we fall back here from a 404
        return loadAccessCodeBranding(org, secondary);
      });
    }

    function loadAccessCodeBranding(org, secondary) {
      var acUrl = org + '/accesscodes/' + secondary;
      //if the secondary param was an invalid group name,
      //we fall back here from a 404
      return loadHeaderImage(acUrl).then(function (response) {
        //the secondary param is a valid access code in the org
        return {
          org: org,
          accessCode: secondary,
          cobranding: response
        };
      }, function () {
        return loadOrgBranding(org);
      });
    }

    /**
     * Attempts to fetch the header information for the url specified
     * @param  {String} url The organization URL suffix to attempt a header GET with
     * @return {Promise}    A promise to fetch a header or return an error
     */
    function loadHeaderImage(url) {
      return $http.get('/apiproxy/collateral/headers/organizations/' + url).then(function (response) {
        var val;
        if (_.has(response, 'data.content')) {
          val = response.data.content.filter(function (headerContent) {
            return headerContent.target === 'image';
          });
        }
        return val && val.length ? val[0].replacement : null;
      });
    }

    /**
     * Creates the appropriate sign-up URL link based on incoming params
     * @param  {String} org        The organization short name
     * @param  {String} group      The optional group short name
     * @param  {String} accessCode The optional access code
     * @param  {String} referral   The optional referral token
     */
    function buildSignUpUrl(org, group, accessCode, referral) {
      //All landing URLs drive to at least a default landing page...
      vm.signupLink = vm.rootDomainUrl + '/signup/' + (org || '');
      if (org && group) {
        vm.signupLink = vm.signupLink + '/' + group;
      }
      if (accessCode) {
        vm.signupLink = vm.signupLink + '?pc=' + accessCode;
        if (referral) {
          vm.signupLink = vm.signupLink + '&ref=' + referral;
        }
      } else if (referral) {
        vm.signupLink = vm.signupLink + '?ref=' + referral;
      }
      $log.debug('signuplink - ' + vm.signupLink);
    }
  }
})();